import { render, staticRenderFns } from "./Addition.vue?vue&type=template&id=2a882add&scoped=true&"
import script from "./Addition.vue?vue&type=script&lang=js&"
export * from "./Addition.vue?vue&type=script&lang=js&"
import style0 from "./Addition.vue?vue&type=style&index=0&id=2a882add&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a882add",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
